import React from 'react';
import './batches.css';

function C2wSuperxBatches() {
  return (
    <div className='C2wSuperxBatches_ctn'>
      <div className='C2wSuperxHeading_ctn_hld'>
        <div className='C2wSuperxHeading_ctn'>
          {'Super-x '}
          <span className='C2wSuperxHeadingSpan'>{'Batches'}</span>
        </div>
      </div>
    </div>
  )
}

export default C2wSuperxBatches
